import * as directives from './modules'

export const directive =  {
    install(Vue, options) {
        // Object.keys() 返回一个数组，值是所有可遍历属性的key名
        Object.keys(directives).forEach(key => {
            // key是自定义指令名字；后面应该是自定义指令的值，key类型是string
            Vue.directive(key, directives[key])
        })
    }
}
